// extracted by mini-css-extract-plugin
export default {"loginCard":"ZQPRlF_pxr0dtbpHZTxY"};